// Import these functions or define them in your component file
import { useState, useEffect } from "react";

// For HTML-based formatting (Word, Pages, Google Docs)
function createRichTextFormatting(indexData) {
  if (!indexData || !indexData.chapters) return "";
  
  // Create HTML content that preserves formatting when copied to office apps
  let content = `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        body { font-family: 'Times New Roman', Times, serif; }
        .title { font-size: 18pt; font-weight: bold; margin-bottom: 8px; }
        .subtitle { font-size: 14pt; font-style: italic; margin-bottom: 20px; color: #444; }
        .chapter { font-size: 14pt; font-weight: bold; margin-top: 16px; }
        .chapter-subtitle { font-size: 12pt; font-style: italic; color: #555; margin-left: 18px; }
        .subchapter { font-size: 12pt; margin-left: 18px; margin-top: 8px; }
        .subchapter-subtitle { font-size: 11pt; font-style: italic; color: #666; margin-left: 36px; }
      </style>
    </head>
    <body>
      <div class="title">${indexData.title || "Indice della tesi"}</div>
      ${indexData.subtitle ? `<div class="subtitle">${indexData.subtitle}</div>` : ''}
  `;
  
  indexData.chapters.forEach((chapter, chIdx) => {
    content += `<div class="chapter">${chIdx + 1}. ${chapter.title}</div>`;
    if (chapter.subtitle) {
      content += `<div class="chapter-subtitle">${chapter.subtitle}</div>`;
    }
    
    if (chapter.subchapters && chapter.subchapters.length > 0) {
      chapter.subchapters.forEach((subchapter, subIdx) => {
        content += `<div class="subchapter">${chIdx + 1}.${subIdx + 1} ${subchapter.title}</div>`;
        if (subchapter.subtitle) {
          content += `<div class="subchapter-subtitle">${subchapter.subtitle}</div>`;
        }
      });
    }
  });
  
  content += `
    </body>
    </html>
  `;
  
  return content;
}

// Word specific formatting with HTML
export function formatForWord(indexData) {
  // Word can handle rich HTML content when pasted
  return createRichTextFormatting(indexData);
}

// Pages specific formatting with HTML
export function formatForPages(indexData) {
  // Pages can handle rich HTML content when pasted
  return createRichTextFormatting(indexData);
}

// Google Docs specific formatting with HTML
export function formatForDocs(indexData) {
  // Google Docs can handle rich HTML content when pasted
  return createRichTextFormatting(indexData);
}

// LaTeX formatting - more comprehensive
export function formatForLatex(indexData) {
  if (!indexData || !indexData.chapters) return "";
  
  let result = `% Template LaTeX per l'indice della tesi
\\documentclass[12pt, a4paper]{report}
\\usepackage[utf8]{inputenc}
\\usepackage[italian]{babel}
\\usepackage{titlesec}
\\usepackage{tocloft}
\\usepackage{hyperref}

% Formattazione personalizzata
\\titleformat{\\chapter}[display]{\\normalfont\\huge\\bfseries}{\\chaptertitlename\\ \\thechapter}{20pt}{\\Huge}
\\titleformat{\\section}{\\normalfont\\Large\\bfseries}{\\thesection}{1em}{}
\\titleformat{\\subsection}{\\normalfont\\large\\bfseries}{\\thesubsection}{1em}{}

\\begin{document}

\\title{\\Huge ${indexData.title || "Indice della tesi"}}
\\author{}
\\date{}
\\maketitle

${indexData.subtitle ? `\\begin{center}\\Large\\textit{${indexData.subtitle}}\\end{center}\\vspace{2cm}` : '\\vspace{2cm}'}

\\tableofcontents
\\newpage

`;
  
  indexData.chapters.forEach((chapter, chIdx) => {
    result += `\\chapter{${chapter.title}}\n`;
    if (chapter.subtitle) result += `\\begin{center}\\textit{${chapter.subtitle}}\\end{center}\\vspace{1cm}\n\n`;
    
    if (chapter.subchapters && chapter.subchapters.length > 0) {
      chapter.subchapters.forEach((subchapter) => {
        result += `\\section{${subchapter.title}}\n`;
        if (subchapter.subtitle) result += `\\textit{${subchapter.subtitle}}\\vspace{0.5cm}\n\n`;
      });
    }
    result += '\n';
  });
  
  result += `\\end{document}`;
  
  return result;
}